// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicBusStopZoneControllerIsCombinationValidData } from './PublicBusStopZoneControllerIsCombinationValidData.gen';
import type { PublicBusStopZoneControllerIsCombinationValidErrors } from './PublicBusStopZoneControllerIsCombinationValidErrors.gen';
import type { PublicBusStopZoneControllerIsCombinationValidResponses } from './PublicBusStopZoneControllerIsCombinationValidResponses.gen';

export class PublicBusStopZoneController {
    /**
     * Check if bus stop zone combination is valid.
     */
    public static isCombinationValid<ThrowOnError extends boolean = false>(options: Options<PublicBusStopZoneControllerIsCombinationValidData, ThrowOnError>) {
        return (options.client ?? client).get<PublicBusStopZoneControllerIsCombinationValidResponses, PublicBusStopZoneControllerIsCombinationValidErrors, ThrowOnError>({ url: '/api/public/bus-stop-zone-combination-is-valid', ...options });
    }
}
